import React from 'react';
import toast from 'simple-pure-toast';
import { capitalize } from './formatters';

export const getActionStatus = (resultado) => {
  switch (resultado) {
    case 0:
      return 'Abierto';
    case 1:
      return 'Con seguimiento';
    case 2:
      return 'Completado';
    default:
      return 'Abierto';
  }
};

export const getClassNameByResult = (result) => {
  const list = {
    Pendiente: 'action__resultado action__resultado--pending',
    Reprobado: 'action__resultado action__resultado--reprobado',
    Aprobado: 'action__resultado action__resultado--completed'
  };

  return list[capitalize(result)];
};

export const itemShaded = (status, value) => {
  switch (status) {
    case 'Low':
      return <div className="action__resultado action__resultado--Low clear">{value}</div>;
    case 'Medium':
      return <div className="action__resultado action__resultado--Medium clear">{value}</div>;
    case 'High':
      return <div className="action__resultado action__resultado--High clear">{value}</div>;
    default:
      return <div className="action__resultado action__resultado--Indistinct clear">{value}</div>;
  }
};

export const priority = [
  { id: 1, value: 'High' },
  { id: 2, value: 'Medium' },
  { id: 3, value: 'Low' }
];

export const typeToast = (tt, ad) => {
  if (tt === 'success') {
    toast.success('¡Listo!', { description: ad, position: 'bottomRight' });
  } else if (tt === 'warning') {
    toast.warning('¡Alerta!', { description: ad, position: 'topRight' });
  } else {
    toast.error('Algo falló', { description: ad, position: 'bottomRight' });
  }
};

export const statusesCommon = [
  'NEW',
  'ERROR',
  'LOADING',
  'SUCCESS'
];

export const typesCommon = [
  'CREATOR_FAILD',
  'LOADING_EFFECT',
  'TOAST'
];

export const msjCommonMap = [
  { title: 'fallo', content: 'Algo falló' },
  { title: 'listo', content: '¡Listo!' },
  { title: 'inconveniente', content: 'Hemos tenido un inconveniente. Intenta nuevamente' },
  { title: 'noHayResultados', content: 'No se han encontrado resultados' },
  { title: 'atencion', content: '¡Atención!' }
];

export const msjCommon = (v) => {
  const miMsj = msjCommonMap.find((o) => o.title === v);
  if (miMsj) {
    return miMsj.content;
  }
  return null;
};
